import React from 'react';
import { CustomColumn } from '../../../types/customColumn'; // ajusta la ruta según tu proyecto

interface RecordBodyProps {
  table: any; // instancia react-table
  noDataMessage?: string;
}

const RecordBody: React.FC<RecordBodyProps> = ({
  table,
  noDataMessage = 'No hay registros disponibles.',
}) => {
  const { getTableBodyProps, page, prepareRow, columns } = table;

  return (
    <tbody {...getTableBodyProps()}>
      {page.length > 0 ? (
        page.map((row: any) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className="dark:border-gray-700 hover:bg-gray-50 transition dark:hover:bg-graydark/40"
              key={row.id}
            >
              {row.cells.map((cell: any) => {
                const column = cell.column as CustomColumn<object>;
                return (
                  <td
                    {...cell.getCellProps()}
                    key={cell.column.id}
                    className="text-gray-900 dark:text-gray-200 px-4 py-4 text-[15px] leading-relaxed"
                  >
                    {'customCell' in column && column.customCell
                      ? column.customCell(cell)
                      : cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={columns.length}
            className="text-gray-600 dark:text-gray-300 dark:border-gray-700 border-b py-4 text-center"
          >
            {noDataMessage}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default RecordBody;
